
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Dialog from '@/components/dialog.vue';

import {
    activityPKRankingList,
    entrancePosterImgSortDescEdit,
    entrancePosterImgIsShowEdit,
    activityPKRankingDelete
} from '@/api/toBApi';

@Component({
    name: '',
    components: {
        PageFooter,
        PickerDate,
        'slz-dialog': Dialog,
    }
})
export default class ProductRecommend extends Vue {

    private list = [];
    private keywords = '';
    private state = null;
    private pageNo = 1;
    private pageSize = 20;
    private total = 0;
    private loading = false;

    private stateList = [
        { value: null, label: '全部' },
        { value: 0, label: '未开始' },
        { value: 1, label: '进行中' },
        { value: 2, label: '已结束' }
    ];

    
    private mounted() {
        this.doSearch();
    }

    private doSearch() {
        this.pageNo = 1
        this.getList()
    }
    private changePage(e) {
        this.pageNo = e
        this.getList()
    }
    private async getList() {
        this.loading = true;
        try {
            let params = {
                Keywords: this.keywords.trim(),
                State: this.state,
                Skip: (this.pageNo - 1) * this.pageSize,
                Take: this.pageSize
            }
            const res: any = await activityPKRankingList(params);
            this.list = res.Result.Results.map(item => {
                item.visible = false;
                item.showIcon1 = false;
                item.visible1 = false;
                item.showIcon2 = false;
                item.SortDescCopy = item.EntrancePosterImgSortDesc;
                return item;
            });
            this.total = res.Result.Total;

        } catch (error) {

        } finally {
            this.loading = false;
        }
    }

    private handleEdit(record: any={}){
        this.$router.push({
            name: 'PKRankingDetails',
            query: {
                id: record.Id || ''
            }
        })
    }
    private handleCopy(record: any={}){

        let query: any = {
            id: record.Id || '',
            copy: 1
        }

        this.$router.push({
            name: 'PKRankingDetails',
            query: query
        })
    }

    private cellMouseEnter(row){
        row.showIcon1 = true;
        row.showIcon2 = true;
    }
    private cellMouseLeave(row){
        if (!row.visible){
            row.showIcon1 = false;
        }
        if (!row.visible1){
            row.showIcon2 = false;
        }
    }

    private handleMouseout(record){
        if (record.visible) return;
        record.showIcon1 = false;
    }
    private async handleSaveSort(record){

        let sort = record.SortDescCopy + '';
        let sortNum = +sort;
        if (isNaN(sortNum) || sortNum < 0 || sortNum > 99999){
            this.$message.error('序号请输入0~99999之间，整数');
            return;
        }
        if (sort.indexOf('.') > -1){
            this.$message.error('序号请输入0~99999之间，整数');
            return;
        }

        try {
            await entrancePosterImgSortDescEdit({ ActivityPKRankingId: record.Id, EntrancePosterImgSortDesc: record.SortDescCopy });
            this.$message.success('操作成功');
            record.visible1 = false;
            record.showIcon2 = false;
            this.doSearch();
        } catch (error) {

        } finally{
        }
    }
    
    private async handleIsShowChange(record){
         this.loading = true;
         try {
            await entrancePosterImgIsShowEdit({ ActivityPKRankingId: record.Id, EntrancePosterImgIsShow: !record.EntrancePosterImgIsShow });
            this.$message.success('操作成功');
            this.doSearch();
        } catch (error) {

        } finally{
             this.loading = false;
        }
    }
    private handleToDelete(record) {
        this.$confirm('是否确认删除PK榜活动【'+record.Name+'】？', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            try {
                await activityPKRankingDelete({ActivityPKRankingId: record.Id});
                this.$message.success('操作成功');
                this.doSearch();
            } catch (error) {

            } finally {
                
            }
        }).catch(() => {
        });
    }
}
